import { render, staticRenderFns } from "./AllocatedBudgetReport.vue?vue&type=template&id=b87f9f62&scoped=true&"
import script from "./AllocatedBudgetReport.vue?vue&type=script&lang=js&"
export * from "./AllocatedBudgetReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87f9f62",
  null
  
)

export default component.exports